export const UNVERIFIED_EMAIL = 'UNVERIFIED_EMAIL' as const;
export const UNVERIFIED_PHONE_NUMBER = 'UNVERIFIED_PHONE_NUMBER' as const;
export const UNVERIFIED_ACCOUNT = 'UNVERIFIED_ACCOUNT' as const;
export const INVALID_CREDENTIALS = 'INVALID_CREDENTIALS' as const;
export const INVALID_ONE_TIME_PASSWORD = 'INVALID_ONE_TIME_PASSWORD' as const;
export const AUTHENTICATION_REQUIRED = 'AUTHENTICATION_REQUIRED' as const;
export const AUTHENTICATION_EMAIL_REQUIRED =
  'AUTHENTICATION_EMAIL_REQUIRED' as const;
export const AUTHENTICATION_PHONE_NUMBER_REQUIRED =
  'AUTHENTICATION_PHONE_NUMBER_REQUIRED' as const;
export const USING_OLD_PASSWORD = 'USING_OLD_PASSWORD' as const;
export const INVALID_USERNAME = 'INVALID_USERNAME' as const;
export const INVALID_PASSWORD = 'INVALID_PASSWORD' as const;
export const USERNAME_NOT_FOUND = 'USERNAME_NOT_FOUND' as const;
export const EMAIL_NOT_FOUND = 'EMAIL_NOT_FOUND' as const;
export const ACCOUNT_BLOCKED = 'ACCOUNT_BLOCKED' as const;
export const PASSWORD_NOT_SUPPORTED = 'PASSWORD_NOT_SUPPORTED' as const;
export const TOKEN_NOT_FOUND = 'TOKEN_NOT_FOUND' as const;
export const MEDIA_EXCEEDS_MAX_FILE_SIZE =
  'MEDIA_EXCEEDS_MAX_FILE_SIZE' as const;
export const UNAUTHORIZED_ACTION = 'UNAUTHORIZED_ACTION' as const;
export const SOCIAL_ACCOUNT_NOT_FOUND = 'SOCIAL_ACCOUNT_NOT_FOUND' as const;
export const TEMPLATE_LIMIT_EXCEEDED = 'TEMPLATE_LIMIT_EXCEEDED' as const;
export const MEMBER_LIMIT_EXCEEDED = 'MEMBER_LIMIT_EXCEEDED' as const;
export const TEMPLATE_IN_USE = 'TEMPLATE_IN_USE' as const;
export const INVALID_INVITE_CODE = 'INVALID_INVITE_CODE' as const;

export type ErrorCode =
  | typeof UNVERIFIED_EMAIL
  | typeof UNVERIFIED_PHONE_NUMBER
  | typeof UNVERIFIED_ACCOUNT
  | typeof INVALID_CREDENTIALS
  | typeof INVALID_ONE_TIME_PASSWORD
  | typeof INVALID_INVITE_CODE
  | typeof AUTHENTICATION_REQUIRED
  | typeof AUTHENTICATION_EMAIL_REQUIRED
  | typeof AUTHENTICATION_PHONE_NUMBER_REQUIRED
  | typeof USING_OLD_PASSWORD
  | typeof INVALID_USERNAME
  | typeof INVALID_PASSWORD
  | typeof USERNAME_NOT_FOUND
  | typeof EMAIL_NOT_FOUND
  | typeof ACCOUNT_BLOCKED
  | typeof PASSWORD_NOT_SUPPORTED
  | typeof TOKEN_NOT_FOUND
  | typeof MEDIA_EXCEEDS_MAX_FILE_SIZE
  | typeof UNAUTHORIZED_ACTION
  | typeof SOCIAL_ACCOUNT_NOT_FOUND
  | typeof TEMPLATE_LIMIT_EXCEEDED
  | typeof MEMBER_LIMIT_EXCEEDED
  | typeof TEMPLATE_IN_USE;
